import { Engine } from 'excalibur';
import { initDialogListeners } from './dialog.listeners';
import { initActionListeners } from './actions.listeners';
import { initGameEventsListeners } from './game-events.listeners';
import { initContextListeners } from './context.listeners';
import { initDungeonEventsListeners } from './dungeon-events.listeners';

export type SFXList = { value: string; probability: number }[];

export const initAllListeners = (game: Engine) => {
  initContextListeners(game);
  initDialogListeners(game);
  initActionListeners(game);
  initGameEventsListeners(game);
  initDungeonEventsListeners(game);
};
